var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('CRUD',{attrs:{"title":"Option","path":this.$route.query.id + '/options/',"fields":this.fields,"width":"500","height":"600"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }